import React from 'react';
import Introduction from '../Introduction/Introduction';
import Map from '../Map/Map';

const About = () => {
    return (
        <div>
            <Introduction></Introduction>
            <Map></Map>
        </div>
    );
};

export default About;